import React from 'react';
import { HvSwitch } from '@hitachivantara/uikit-react-core';

import { Icon, Select } from '@iq/react-components';
import { SEVERITIES, SEVERITY_ICONS, SEVERITY_COLORS, DELIVERY_OPTIONS } from '../../constants';

const NotificationRulesForm = ({ stateChangeSettings, onChange }) => {
  const handleToggle = (severity) => {
    const current = stateChangeSettings[severity];
    const isEnabled = current?.app || current?.email;
    onChange({
      ...stateChangeSettings,
      [severity]: { app: !isEnabled, email: !isEnabled },
    });
  };

  const handleDeliveryChange = (severity, selected) => {
    const values = selected ? selected.map((s) => s.value || s) : [];
    onChange({
      ...stateChangeSettings,
      [severity]: {
        app: values.includes('app'),
        email: values.includes('email'),
      },
    });
  };

  return (
    <div className="notification-rules-form">
      <div className="notification-rules-form__col-headers">
        <div className="notification-rules-form__col-toggle">On/Off</div>
        <div className="notification-rules-form__col-conditions">Conditions</div>
        <div className="notification-rules-form__col-delivery">Delivery options</div>
      </div>
      <div className="notification-rules-form__sub-label">Notify when alarm reaches status:</div>

      {SEVERITIES.map((state) => {
        const setting = stateChangeSettings[state] || { app: false, email: false };
        const enabled = setting.app || setting.email;
        const deliveryValue = DELIVERY_OPTIONS.filter((o) => setting[o.value]);

        return (
          <div
            key={state}
            className="notification-rules-row"
          >
            <div className="notification-rules-row__toggle">
              <HvSwitch
                checked={enabled}
                onChange={() => handleToggle(state)}
              />
            </div>
            <div className="notification-rules-row__condition">
              <Icon
                icon={SEVERITY_ICONS[state]}
                size="s"
                color={SEVERITY_COLORS[state]}
              />
              <span className="severity-label">{state}</span>
            </div>
            <div className="notification-rules-row__delivery">
              <Select
                isMulti
                value={deliveryValue}
                options={DELIVERY_OPTIONS}
                onChange={(selected) => handleDeliveryChange(state, selected)}
                placeholder="Select..."
                isClearable={false}
              />
            </div>
          </div>
        );
      })}
    </div>
  );
};

export default NotificationRulesForm;
